export const MITACS_DETAILED_TASKS = [
    {
      id: 1,
      name: "Get client consent and educate about Mitacs program",
      prompt: "Get client consent and educate about Mitacs program",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "research",
      completed: true,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "1-1",
          name: "Schedule initial meeting with client",
          prompt:
            "Schedule initial meeting with client to discuss Mitacs program",
          completed: true,
          action: "follow_up",
        },
        {
          id: "1-2",
          name: "Prepare Mitacs program overview presentation",
          prompt:
            "Create presentation explaining Mitacs benefits and requirements",
          completed: true,
          action: "create_document",
        },
        {
          id: "1-3",
          name: "Obtain signed consent form",
          prompt: "Get client to sign consent form for Mitacs participation",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 2,
      name: "Candidate info from client to confirm eligibility",
      prompt:
        "Get candidate information from client to confirm Mitacs eligibility",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "2-1",
          name: "Request candidate resume from client",
          prompt: "Ask client to send candidate resume for eligibility review",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Program - Candidate Resume Request",
          emailBody: "Hi [Client Name],\n\nAs part of the Mitacs program eligibility process, we need to review the candidate's resume to confirm they meet the program requirements.\n\nPlease send us the candidate's resume at your earliest convenience. We'll verify that the candidate is less than 21 months out of a Mitacs eligible academic institution.\n\nThank you for your prompt attention to this matter.\n\nBest regards,\n[Your Name]",
        },
        {
          id: "2-2",
          name: "Verify candidate is less than 21 months out of Mitacs eligible institution",
          prompt:
            "Check that candidate graduated less than 21 months ago from eligible academic institution",
          completed: false,
          action: "research",
        },
      ],
    },
    {
      id: 3,
      name: "[Optional - RFI] If no candidate, ask client to find, complete RFI",
      prompt: "If no candidate available, offer RFI to help find candidate",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "3-1",
          name: "Offer RFI to help find candidate",
          prompt:
            "Present RFI form option to client to help find suitable candidate",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Program - RFI Form to Find Candidate",
          emailBody: "Hi [Client Name],\n\nSince we don't have a candidate identified yet, I'd like to offer you the option to use our RFI (Request for Information) form to help find a suitable candidate for your Mitacs project.\n\nHere is the successful RFI form that we've used in the past: [RFI Form Link]\n\nThis form will help us identify qualified candidates from Mitacs eligible academic institutions. Please review it and let me know if you'd like to proceed with this approach.\n\nBest regards,\n[Your Name]",
        },
        {
          id: "3-2",
          name: "Get client approval for RFI",
          prompt: "Obtain client approval to proceed with RFI process",
          completed: false,
          action: "follow_up",
        },
        {
          id: "3-3",
          name: "Send RFI to Leslie for submission",
          prompt: "Forward RFI form to Leslie for her to submit",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs RFI Form - Ready for Submission",
          emailBody: "Hi Leslie,\n\nThe client has approved the RFI form for their Mitacs project. Please find the completed RFI form attached.\n\nCould you please submit this RFI on our behalf? Let me know if you need any additional information.\n\nThank you!\n\nBest regards,\n[Your Name]",
        },
        {
          id: "3-4",
          name: "Submit job posting on university/college job boards",
          prompt:
            "Post job on George Brown, Sheridan, McGill, Waterloo, and York employer portals",
          completed: false,
          action: "post_share",
        },
        {
          id: "3-5",
          name: "Check job boards and shared email for applications",
          prompt:
            "Monitor job boards and shared email for resumes and cover letters",
          completed: false,
          action: "follow_up",
          isRecurring: true,
          frequency: "daily",
        },
        {
          id: "3-6",
          name: "Share applicants (resumes) with clients",
          prompt: "Forward candidate resumes to client for review",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Program - Candidate Applications for Review",
          emailBody: "Hi [Client Name],\n\nWe've received several applications for your Mitacs project position. I've attached the resumes and cover letters from the candidates for your review.\n\nPlease review these applications and let me know which candidates you'd like to move forward with. Once you've made your selection, we can proceed with the next steps in the Mitacs application process.\n\nIf you have any questions about any of the candidates, please don't hesitate to reach out.\n\nBest regards,\n[Your Name]",
        },
      ],
    },
    {
      id: 4,
      name: "Create job description/job title for the position",
      prompt: "Create job description/job title for the position",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "create_document",
      completed: true,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "4-1",
          name: "Define role responsibilities and requirements",
          prompt:
            "Outline key responsibilities and qualifications for the position",
          completed: true,
          action: "create_document",
        },
        {
          id: "4-2",
          name: "Set salary range and benefits",
          prompt: "Determine competitive salary range and benefits package",
          completed: true,
          action: "research",
        },
        {
          id: "4-3",
          name: "Review and finalize job description",
          prompt:
            "Review job description with client and make final adjustments",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 5,
      name: "Prepare draft project proposal",
      prompt:
        "Prepare draft project proposal using awarded project proposal as reference",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "create_document",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "5-1",
          name: "Review successful awarded project proposal template",
          prompt:
            "Reference the successfully completed and awarded project proposal format",
          completed: false,
          action: "research",
        },
        {
          id: "5-2",
          name: "Research project objectives and scope",
          prompt:
            "Define clear project objectives, scope, and expected outcomes",
          completed: false,
          action: "research",
        },
        {
          id: "5-3",
          name: "Outline project timeline and milestones",
          prompt:
            "Create detailed timeline with key milestones and deliverables",
          completed: false,
          action: "create_document",
        },
        {
          id: "5-4",
          name: "Draft budget and resource requirements",
          prompt: "Prepare budget breakdown and identify required resources",
          completed: false,
          action: "create_document",
        },
        {
          id: "5-5",
          name: "Write executive summary",
          prompt:
            "Create compelling executive summary highlighting project value",
          completed: false,
          action: "create_document",
        },
      ],
    },
    {
      id: 6,
      name: "If candidate Ontario based, seek support from Ryan (GBC)",
      prompt:
        "If candidate is Ontario-based, contact Ryan at George Brown College for support",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "send_email",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "6-1",
          name: "Send draft email to Ryan at GBC",
          prompt:
            "Contact Ryan at George Brown College for Ontario-based candidate support",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Project - Request for Support (Ontario-Based Candidate)",
          emailBody: "Hi Ryan,\n\nI hope this email finds you well. We have an Ontario-based candidate for a Mitacs project and would appreciate your support.\n\n[Brief project description]\n\nCandidate details:\n- Name: [Candidate Name]\n- Institution: [Institution Name]\n- Department: [Department]\n\nCould you please assist us with the next steps for this Ontario-based candidate? Any guidance or support you can provide would be greatly appreciated.\n\nThank you for your time and assistance.\n\nBest regards,\n[Your Name]",
        },
      ],
    },
    {
      id: 7,
      name: "If not Ontario-based, find academic supervisor at candidate's institution",
      prompt:
        "Find academic supervisor at candidate's institution if not Ontario-based",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "research",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "7-1",
          name: "Try to find faculty member from candidate's academic department",
          prompt:
            "Research and identify potential faculty supervisors in candidate's department",
          completed: false,
          action: "research",
        },
        {
          id: "7-2",
          name: "Send draft email to potential supervisor",
          prompt: "Contact potential academic supervisor with project details",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Project - Academic Supervisor Opportunity",
          emailBody: "Dear Professor [Supervisor Name],\n\nI hope this email finds you well. I'm reaching out regarding a Mitacs research project opportunity that may be of interest to you.\n\nWe have a candidate from [Institution Name] in the [Department] department who is interested in participating in a Mitacs project. The project involves [brief project description].\n\nWe're looking for an academic supervisor to support this project. Given your expertise in [relevant field], we thought you might be interested in this opportunity.\n\nWould you be available to discuss this further? I'd be happy to provide more details about the project and answer any questions you may have.\n\nThank you for your consideration.\n\nBest regards,\n[Your Name]",
        },
        {
          id: "7-3",
          name: "Send supervisor info to Leslie/Mitacs Rep for eligibility check",
          prompt:
            "Forward identified supervisor information to Leslie or Mitacs representative for eligibility verification",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Project - Supervisor Information for Eligibility Check",
          emailBody: "Hi Leslie,\n\nWe've identified a potential academic supervisor for our Mitacs project:\n\nSupervisor Details:\n- Name: [Supervisor Name]\n- Institution: [Institution Name]\n- Department: [Department]\n- Email: [Email]\n- Phone: [Phone]\n\nCandidate Details:\n- Name: [Candidate Name]\n- Institution: [Candidate Institution]\n\nCould you please verify the eligibility of this supervisor for the Mitacs program? Let me know if you need any additional information.\n\nThank you!\n\nBest regards,\n[Your Name]",
        },
      ],
    },
    {
      id: 8,
      name: "Post job description in Mitacs portal and university job board",
      prompt: "Post job description in Mitacs portal and university job board",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "submit_application",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "8-1",
          name: "Sign in to Mitacs portal",
          prompt: "Access Mitacs portal to begin job posting process",
          completed: false,
          action: "access_portal",
        },
        {
          id: "8-2",
          name: "Upload job description to Mitacs portal",
          prompt: "Post job description in Mitacs RAP portal",
          completed: false,
          action: "submit_application",
        },
        {
          id: "8-3",
          name: "Post to George Brown Employer Portal",
          prompt: "Submit job posting to George Brown College employer portal",
          completed: false,
          action: "post_share",
        },
        {
          id: "8-4",
          name: "Post to Sheridan College Employer Portal",
          prompt: "Submit job posting to Sheridan College employer portal",
          completed: false,
          action: "post_share",
        },
        {
          id: "8-5",
          name: "Post to McGill University Employer Portal",
          prompt: "Submit job posting to McGill University employer portal",
          completed: false,
          action: "post_share",
        },
        {
          id: "8-6",
          name: "Post to University of Waterloo Employer Portal",
          prompt:
            "Submit job posting to University of Waterloo employer portal",
          completed: false,
          action: "post_share",
        },
        {
          id: "8-7",
          name: "Post to York University Employer Portal",
          prompt: "Submit job posting to York University employer portal",
          completed: false,
          action: "post_share",
        },
      ],
    },
    {
      id: 9,
      name: "Begin application in Mitacs portal",
      prompt:
        "Start application process in Mitacs portal once all participants are identified",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "access_portal",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "9-1",
          name: "Sign in to Mitacs portal",
          prompt: "Access Mitacs portal to begin application",
          completed: false,
          action: "access_portal",
        },
        {
          id: "9-2",
          name: "Fill out each section and follow up with participants",
          prompt:
            "Complete all application sections and check in with all participants to complete their sections",
          completed: false,
          action: "follow_up",
        },
        {
          id: "9-3",
          name: "Send sign-off request to all participants",
          prompt:
            "Request final sign-off from each participant once all sections are completed",
          completed: false,
          action: "send_email",
        },
        {
          id: "9-4",
          name: "Ensure supervisor uploads ORS document",
          prompt:
            "Verify that supervisor has uploaded the ORS document before submission",
          completed: false,
          action: "follow_up",
        },
        {
          id: "9-5",
          name: "Submit application once ORS document is uploaded",
          prompt:
            "Submit final application to Mitacs after ORS document is confirmed uploaded",
          completed: false,
          action: "submit_application",
        },
      ],
    },
    {
      id: 10,
      name: "Get all participants to sign off and secure ORS approval",
      prompt: "Get all participants to sign off and secure ORS approval",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "10-1",
          name: "Prepare participant sign-off forms",
          prompt: "Create forms for all participants to sign",
          completed: false,
          action: "create_document",
        },
        {
          id: "10-2",
          name: "Collect signatures from client, advisor, and student",
          prompt: "Obtain signed forms from all project participants",
          completed: false,
          action: "follow_up",
        },
        {
          id: "10-3",
          name: "Submit to university ORS office",
          prompt: "Send all signed documents to Office of Research Services",
          completed: false,
          action: "submit_application",
        },
        {
          id: "10-4",
          name: "Follow up on ORS approval status",
          prompt: "Check status and address any ORS concerns or requirements",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 11,
      name: "Wait for funds to be received (minimum 6 weeks before project start)",
      prompt:
        "Wait for funds to be received (minimum 6 weeks before project start)",
      model: "gpt-4",
      isRecurring: true,
      frequency: "weekly",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "weekly",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "11-1",
          name: "Monitor application status weekly",
          prompt: "Check Mitacs portal for application status updates",
          completed: false,
          action: "follow_up",
          isRecurring: true,
          frequency: "weekly",
        },
        {
          id: "11-2",
          name: "Confirm receipt of funds notification",
          prompt: "Verify that funds have been approved and transferred",
          completed: false,
          action: "update_record",
        },
        {
          id: "11-3",
          name: "Coordinate project start date",
          prompt:
            "Confirm project start date aligns with fund receipt timeline",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 12,
      name: "Get client to process invoice once received from Mitacs",
      prompt:
        "Follow up with client to pay invoice once Mitacs issues it after project award",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "12-1",
          name: "Monitor for Mitacs invoice issuance",
          prompt:
            "Check for invoice from Mitacs after project has been awarded",
          completed: false,
          action: "follow_up",
          isRecurring: true,
          frequency: "weekly",
        },
        {
          id: "12-2",
          name: "Forward invoice to client",
          prompt: "Send Mitacs invoice to client for payment processing",
          completed: false,
          action: "send_email",
          emailSubject: "Mitacs Project Invoice - Payment Required",
          emailBody: "Hi [Client Name],\n\nGreat news! Your Mitacs project has been awarded. Mitacs has issued an invoice for the project.\n\nI've attached the invoice for your review and payment processing. Please process this invoice at your earliest convenience.\n\nInvoice Details:\n- Invoice Number: [Invoice Number]\n- Amount: [Amount]\n- Due Date: [Due Date]\n\nIf you have any questions about the invoice or need any additional information, please don't hesitate to reach out.\n\nThank you!\n\nBest regards,\n[Your Name]",
        },
        {
          id: "12-3",
          name: "Send first reminder if payment not received (7 days after invoice)",
          prompt: "Send first payment reminder to client if invoice not paid within 7 days",
          completed: false,
          action: "send_email",
          isRecurring: false,
          emailSubject: "Reminder: Mitacs Project Invoice Payment Due",
          emailBody: "Hi [Client Name],\n\nThis is a friendly reminder that the Mitacs project invoice is due for payment.\n\nInvoice Details:\n- Invoice Number: [Invoice Number]\n- Amount: [Amount]\n- Due Date: [Due Date]\n\nPlease process the payment at your earliest convenience. If you've already sent the payment, please disregard this reminder and let me know so I can confirm receipt.\n\nIf you have any questions or concerns, please don't hesitate to reach out.\n\nThank you!\n\nBest regards,\n[Your Name]",
        },
        {
          id: "12-4",
          name: "Send second reminder if payment not received (14 days after invoice)",
          prompt: "Send second payment reminder to client if invoice not paid within 14 days",
          completed: false,
          action: "send_email",
          isRecurring: false,
          emailSubject: "Second Reminder: Mitacs Project Invoice Payment Overdue",
          emailBody: "Hi [Client Name],\n\nI'm following up on the Mitacs project invoice that is now overdue.\n\nInvoice Details:\n- Invoice Number: [Invoice Number]\n- Amount: [Amount]\n- Original Due Date: [Due Date]\n\nWe need to process this payment to ensure the project can proceed as planned. Please arrange payment as soon as possible.\n\nIf there are any issues preventing payment or if you need to discuss payment terms, please let me know immediately so we can work together to resolve this.\n\nThank you for your prompt attention to this matter.\n\nBest regards,\n[Your Name]",
        },
        {
          id: "12-5",
          name: "Follow up with client on invoice payment status",
          prompt: "Check in with client to confirm invoice payment status and address any issues",
          completed: false,
          action: "follow_up",
          isRecurring: true,
          frequency: "weekly",
        },
        {
          id: "12-6",
          name: "Confirm payment received and verify funds",
          prompt: "Verify that client has paid the Mitacs invoice and confirm funds received",
          completed: false,
          action: "update_record",
        },
        {
          id: "12-7",
          name: "Mark invoice as paid in records",
          prompt: "Update opportunity tracking system to mark invoice as paid and update payment status",
          completed: false,
          action: "update_record",
        },
      ],
    },
  ];
